import api from './api';

// Serviço para operações com pessoas

export const pessoasService = {
  
  // Listar extensões disponíveis
  async listarExtensoes() {
    try {
      const response = await api.get('/pessoas/extensoes');
      return {
        success: response.data.success,
        data: response.data.data || []
      };
    } catch (error) {
      console.error('Erro ao listar extensões:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: []
      };
    }
  },

  // Listar pessoas por extensão
  async listarPessoasPorExtensao(extensaoId, { page = 1, limit = 50, nome = '' } = {}) {
    try {
      const params = { page, limit };
      if (nome) params.nome = nome;
      
      const response = await api.get(`/pessoas/por-extensao/${extensaoId}`, { params });
      
      return {
        success: response.data.success,
        data: response.data.data?.pessoas || [],
        pagination: response.data.data?.pagination || {}
      };
    } catch (error) {
      console.error('Erro ao listar pessoas por extensão:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: [],
        pagination: {}
      };
    }
  },

  // Buscar pessoa por ID
  async buscarPessoa(id) {
    try {
      const response = await api.get(`/pessoas/${id}`);
      return {
        success: true,
        data: response.data?.data || null
      };
    } catch (error) {
      console.error('Erro ao buscar pessoa:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        data: null
      };
    }
  }
};

export default pessoasService;